import { createFileRoute } from "@tanstack/react-router"

import { HomePageHeader } from "../pages/HomePage"

export const Route = createFileRoute("/home")({
  beforeLoad: () => ({ customHeaderComponent: HomePageHeader }),
})
